import axios from '../api/https'

// // note: 获取附近位置poi列表
// const getVisitHomeList = data => axios.get(`vradm/admin/material/showList`, data)
const getVisitHomeList = params =>
 axios.get(`vradm/api/material/display/jTi6D7GQLNZUxH3`)

 const getDataByChannelId = params =>
 axios.get(`vradm/api/material/display/` + params)
/* const getList = data =>
  axios.get(`vradm/admin/material?showList=1`, data) */

// // const getConnectResult = params =>
// //   axios.get(`mos/map/addressmanagement/getinputtips`, {
// //     params
// //   })
// // const getSearchResult = params =>
// //   axios.get(`mos/map/addressmanagement/getpoisbykeyword`, {
// //     params
// //   })
// // const getregeobypoint = params =>
// //   axios.get(`mos/map/addressmanagement/getregeobypoint`, {
// //     params
// //   })

export default {
  getVisitHomeList,
  getDataByChannelId,
  //getList
  // getConnectResult,
  // getSearchResult,
  // getregeobypoint
}
